export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeaturedText.vue?vue&type=template&id=74b1004b&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedText.vue?vue&type=template&id=74b1004b&scoped=true&
// module id = 131
// module chunks = 0